import { app } from '../utils/store'
import Swiper from "swiper/bundle"

export default class Slider {
    constructor({ element }) {
        this.element = element

        this.create(this.element)
    }

    create = (entry) => {
        if(entry) {
            this.slider = {
                section: entry,
                swiper: entry.querySelector('.swiper'),
            }

            if (this.slider?.swiper) {
                this.slider.actions = this.slider.section.querySelector(".actions")
                this.slider.controls = this.slider.section.querySelector(".controls")
                this.slider.pagination = this.slider.section.querySelector(".pagination")
    
                this.slider.swiper = new Swiper(this.slider.swiper, {
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.slider.controls.querySelector("[data-next]"),
                        prevEl: this.slider.controls.querySelector("[data-prev]"),
                        clickable: true,
                    },
                    pagination: this.slider.pagination ? {
                        el: this.slider.pagination,
                        clickable: true,
                    } : false,
                    centerInsufficientSlides: true,
                    autoHeight: false,
                })

                if(this.slider?.swiper) {
                    let slide = this.slider.swiper.el.querySelector(".swiper-slide figure")
                    this.slider.section.style.setProperty('--image-height', `${slide.clientHeight}px`)

                    window.addEventListener('resize', (event) => {
                        this.slider.section.style.setProperty('--image-height', `${slide.clientHeight}px`)
                    })
                }

                if(this.slider?.actions) {
                    this.slider.section.style.setProperty('--actions-height', `${this.slider.actions.clientHeight}px`)

                    window.addEventListener('resize', (event) => {
                        this.slider.section.style.setProperty('--actions-height', `${this.slider.actions.clientHeight}px`)
                    })
                }
            }
        } else {
            console.log('Errore: elemento `entry` mancante')
        }
    }
}